import React, { Component } from 'react';

import './logo.css';

export class Logo extends Component {
  render() {
    return <div className="yandex-logo-image header__yandex-logo-image" />;
  }
}
